import styled from 'styled-components/macro'

const UpgradedBasicNemesisCardGridWrapper = styled('div')`
  margin-top: 24px;
  width: 100%;
`

export default UpgradedBasicNemesisCardGridWrapper
